/* Tap · 3D cards. Plain WebGL, no library.
   The card faces are drawn on a canvas from the real artwork (the "tap." wordmark, the NFC mark,
   the SCAN ME QR on the back) and lit like a satin print. Scroll turns them; the pointer tilts them.
   Markup: <div class="trd-c3d" data-card3d="single|turn" data-designs="tap-black,northwind,…"><canvas></canvas>…fallback…</div> */
(function () {
  'use strict';
  if (window.TapCard3D) return;
  window.TapCard3D = true;

  var W = 3.2, H = 2.02, R = 0.12, T = 0.032, SEG = 10;   // ISO card, 85.6 × 54 mm, in world units
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- small maths ---------- */
  function persp(fov, a, n, f) { var t = 1 / Math.tan(fov / 2), nf = 1 / (n - f); return [t / a, 0, 0, 0, 0, t, 0, 0, 0, 0, (f + n) * nf, -1, 0, 0, 2 * f * n * nf, 0]; }
  function mul(a, b) { var o = new Array(16); for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) { var s = 0; for (var k = 0; k < 4; k++) s += a[k * 4 + r] * b[c * 4 + k]; o[c * 4 + r] = s; } return o; }
  function trans(x, y, z) { return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, y, z, 1]; }
  function scal(x, y, z) { return [x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1]; }
  function rx(a) { var c = Math.cos(a), s = Math.sin(a); return [1, 0, 0, 0, 0, c, s, 0, 0, -s, c, 0, 0, 0, 0, 1]; }
  function ry(a) { var c = Math.cos(a), s = Math.sin(a); return [c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1]; }
  function rz(a) { var c = Math.cos(a), s = Math.sin(a); return [c, s, 0, 0, -s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ss(a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  var D = Math.PI / 180;

  /* ---------- geometry: rounded slab with front, back and edge ---------- */
  function slab() {
    var pts = [], cs = [[W / 2 - R, H / 2 - R], [-W / 2 + R, H / 2 - R], [-W / 2 + R, -H / 2 + R], [W / 2 - R, -H / 2 + R]];
    for (var c = 0; c < 4; c++) for (var k = 0; k <= SEG; k++) {
      var a = (c * 90 + 90 * k / SEG) * D;
      pts.push([cs[c][0] + R * Math.cos(a), cs[c][1] + R * Math.sin(a), Math.cos(a), Math.sin(a)]);
    }
    var v = [], z = T / 2, n = pts.length;
    function push(x, y, zz, nx, ny, nz, u, vv, f) { v.push(x, y, zz, nx, ny, nz, u, vv, f); }
    for (var i = 0; i < n; i++) {
      var p = pts[i], q = pts[(i + 1) % n];
      push(0, 0, z, 0, 0, 1, .5, .5, 0); push(p[0], p[1], z, 0, 0, 1, p[0] / W + .5, p[1] / H + .5, 0); push(q[0], q[1], z, 0, 0, 1, q[0] / W + .5, q[1] / H + .5, 0);
      push(0, 0, -z, 0, 0, -1, .5, .5, 1); push(q[0], q[1], -z, 0, 0, -1, .5 - q[0] / W, q[1] / H + .5, 1); push(p[0], p[1], -z, 0, 0, -1, .5 - p[0] / W, p[1] / H + .5, 1);
      push(p[0], p[1], z, p[2], p[3], 0, 0, 0, 2); push(p[0], p[1], -z, p[2], p[3], 0, 0, 0, 2); push(q[0], q[1], z, q[2], q[3], 0, 0, 0, 2);
      push(q[0], q[1], z, q[2], q[3], 0, 0, 0, 2); push(p[0], p[1], -z, p[2], p[3], 0, 0, 0, 2); push(q[0], q[1], -z, q[2], q[3], 0, 0, 0, 2);
    }
    return new Float32Array(v);
  }

  /* ---------- the artwork ---------- */
  var TW = 1024, TH = 512, CW = 1024, CH = 646;            // texture is power-of-two; the face is drawn at card ratio then squeezed
  var NFC = ['M4.5 15.5V9l6 6.5V9', 'M14.4 7.9a6 6 0 0 1 0 8.2', 'M17.5 5.7a9.4 9.4 0 0 1 0 12.6'];
  var DESIGNS = {
    'tap-black':  { bg: ['#141416', '#050506'], ink: '#F4F4F2', edge: [0.07, 0.07, 0.075], sheen: 1.0, front: tapFront, back: tapBack },
    'tap-white':  { bg: ['#FFFFFF', '#E9E9E6'], ink: '#151515', edge: [0.86, 0.86, 0.85], sheen: 0.55, front: tapFront, back: tapBack },
    'tap-purple': { bg: ['#6A61B4', '#4E4692'], ink: '#FFFFFF', edge: [0.30, 0.27, 0.55], sheen: 0.8, front: tapFront, back: tapBack },
    'northwind':  { bg: ['#16483F', '#0B2B26'], ink: '#F3EEE2', gold: '#D2B272', edge: [0.05, 0.16, 0.14], sheen: 0.9, front: nwFront, back: brandBack, site: 'northwind.com' },
    'harbor':     { bg: ['#1D3366', '#101D3F'], ink: '#FFFFFF', edge: [0.07, 0.11, 0.24], sheen: 0.85, front: hbFront, back: brandBack, site: 'harborretail.com' },
    'summit':     { bg: ['#F7F3EC', '#E6DFD2'], ink: '#1E1B18', accent: '#C2532B', edge: [0.88, 0.85, 0.80], sheen: 0.5, front: smFront, back: brandBack, site: 'summitfoods.com' }
  };
  var ART = { logo: '', qr: '', icon: null };

  function base(g, d) {
    var gr = g.createLinearGradient(0, 0, CW * .35, CH * 1.1);
    gr.addColorStop(0, d.bg[0]); gr.addColorStop(1, d.bg[1]);
    g.fillStyle = gr; g.fillRect(0, 0, CW, CH);
  }
  function nfc(g, x, y, s, col) {
    g.save(); g.translate(x, y); g.scale(s / 24, s / 24); g.strokeStyle = col; g.lineWidth = 2.1; g.lineCap = 'round'; g.lineJoin = 'round';
    NFC.forEach(function (p) { g.stroke(new Path2D(p)); }); g.restore();
  }
  function spaced(g, text, x, y, size, weight, sp, col, family) {
    g.font = weight + ' ' + size + 'px ' + (family || "Inter, 'Helvetica Neue', Arial, sans-serif"); g.fillStyle = col; g.textBaseline = 'alphabetic';
    for (var i = 0; i < text.length; i++) { g.fillText(text[i], x, y); x += g.measureText(text[i]).width + sp; }
    return x;
  }
  function spacedWidth(g, text, size, weight, sp, family) {
    g.font = weight + ' ' + size + 'px ' + (family || "Inter, 'Helvetica Neue', Arial, sans-serif"); var w = 0;
    for (var i = 0; i < text.length; i++) w += g.measureText(text[i]).width + sp; return w - sp;
  }
  function logo(g, cx, cy, w, col) {
    if (!ART.logo) return;
    var s = w / 166.967; g.save(); g.translate(cx - w / 2 - 44.375 * s, cy - 81.311 * s / 2 - 87.375 * s); g.scale(s, s);
    g.fillStyle = col; g.fill(new Path2D(ART.logo)); g.restore();
  }
  function qrTile(g, d) {
    var tw = CW * .245, th = tw * 1.18, x = CW - CW * .064 - tw, y = CH - CH * .07 - th, r = tw * .08;
    g.fillStyle = '#FFFFFF'; g.beginPath(); g.roundRect ? g.roundRect(x, y, tw, th, r) : g.rect(x, y, tw, th); g.fill();
    var q = tw * .8, qx = x + (tw - q) / 2, qy = y + tw * .1;
    if (ART.qr) { g.save(); g.translate(qx, qy); g.scale(q / 33, q / 33); g.fillStyle = '#141414'; g.fill(new Path2D(ART.qr)); g.restore(); }
    if (ART.icon) { var ic = q * .22; g.save(); g.beginPath(); g.roundRect ? g.roundRect(qx + q / 2 - ic / 2, qy + q / 2 - ic / 2, ic, ic, ic * .26) : g.rect(qx + q / 2 - ic / 2, qy + q / 2 - ic / 2, ic, ic); g.clip(); g.drawImage(ART.icon, qx + q / 2 - ic / 2, qy + q / 2 - ic / 2, ic, ic); g.restore(); }
    var fs = CW * .019, tw2 = spacedWidth(g, 'SCAN ME', fs, 700, fs * .16);
    spaced(g, 'SCAN ME', x + tw / 2 - tw2 / 2, y + th - tw * .07, fs, 700, fs * .16, '#141414');
  }
  function tapFront(g, d) { base(g, d); logo(g, CW / 2, CH / 2, CW * .393, d.ink); nfc(g, CW * .062, CH * .79, CW * .068, d.ink); }
  function tapBack(g, d) {
    base(g, d); var fs = CW * .021;
    spaced(g, 'NFC POWERED BUSINESS CARD', CW * .064, CH * .115, fs, 600, fs * .2, d.ink);
    spaced(g, 'GETTAP.CO', CW * .064, CH * .915, fs, 600, fs * .2, d.ink);
    nfc(g, CW * .876, CH * .07, CW * .062, d.ink); qrTile(g, d);
  }
  function nwMark(g, cx, cy, r, col) {
    g.save(); g.strokeStyle = col; g.fillStyle = col; g.lineWidth = r * .16;
    g.beginPath(); g.arc(cx, cy, r, 0, Math.PI * 2); g.stroke();
    g.beginPath(); g.moveTo(cx, cy - r * .7); g.lineTo(cx + r * .34, cy + r * .5); g.lineTo(cx, cy + r * .28); g.lineTo(cx - r * .34, cy + r * .5); g.closePath(); g.fill(); g.restore();
  }
  function nwFront(g, d) {
    base(g, d);
    var fs = CW * .085, tw = spacedWidth(g, 'Northwind', fs, 600, -fs * .02), mr = fs * .42, gap = fs * .32, total = mr * 2 + gap + tw, x = CW / 2 - total / 2;
    nwMark(g, x + mr, CH / 2 - fs * .3, mr, d.gold);
    spaced(g, 'Northwind', x + mr * 2 + gap, CH / 2, fs, 600, -fs * .02, d.ink);
    nfc(g, CW * .876, CH * .79, CW * .062, d.gold);
  }
  function hbFront(g, d) {
    base(g, d);
    var serif = "Georgia, 'Times New Roman', serif", fs = CW * .1, sp = fs * .22, tw = spacedWidth(g, 'HARBOR', fs, 400, sp, serif);
    spaced(g, 'HARBOR', CW / 2 - tw / 2, CH / 2 + fs * .12, fs, 400, sp, d.ink, serif);
    g.fillStyle = d.ink; g.globalAlpha = .55; g.fillRect(CW / 2 - CW * .07, CH / 2 + fs * .42, CW * .14, 2.5); g.globalAlpha = 1;
    var f2 = CW * .022, w2 = spacedWidth(g, 'RETAIL GROUP', f2, 600, f2 * .5);
    spaced(g, 'RETAIL GROUP', CW / 2 - w2 / 2, CH / 2 + fs * .82, f2, 600, f2 * .5, d.ink);
    nfc(g, CW * .062, CH * .79, CW * .062, d.ink);
  }
  function smMark(g, x, y, s, col) {
    g.save(); g.fillStyle = col; g.beginPath(); g.moveTo(x, y + s); g.lineTo(x + s * .42, y + s * .18); g.lineTo(x + s * .62, y + s * .52); g.lineTo(x + s * .76, y + s * .34); g.lineTo(x + s * 1.1, y + s); g.closePath(); g.fill(); g.restore();
  }
  function smFront(g, d) {
    base(g, d);
    var fs = CW * .07, tw = spacedWidth(g, 'Summit Foods', fs, 700, -fs * .03), ms = fs * 1.05, total = ms * 1.1 + fs * .35 + tw, x = CW / 2 - total / 2;
    smMark(g, x, CH / 2 - ms * .78, ms, d.accent);
    spaced(g, 'Summit Foods', x + ms * 1.1 + fs * .35, CH / 2, fs, 700, -fs * .03, d.ink);
    nfc(g, CW * .062, CH * .79, CW * .062, d.ink);
  }
  function brandBack(g, d) {
    base(g, d); var fs = CW * .021, ink = d.ink;
    if (d.front === nwFront) { nwMark(g, CW * .064 + CW * .022, CH * .1, CW * .022, d.gold); spaced(g, 'Northwind', CW * .064 + CW * .056, CH * .118, CW * .032, 600, 0, ink); }
    else if (d.front === hbFront) spaced(g, 'HARBOR', CW * .064, CH * .122, CW * .036, 400, CW * .008, ink, "Georgia, 'Times New Roman', serif");
    else { smMark(g, CW * .064, CH * .07, CW * .04, d.accent); spaced(g, 'Summit Foods', CW * .064 + CW * .052, CH * .118, CW * .03, 700, 0, ink); }
    spaced(g, d.site.toUpperCase(), CW * .064, CH * .915, fs, 600, fs * .2, ink);
    nfc(g, CW * .876, CH * .07, CW * .062, d.gold || ink); qrTile(g, d);
  }

  function face(name, back) {
    var d = DESIGNS[name] || DESIGNS['tap-black'];
    var c = document.createElement('canvas'); c.width = CW; c.height = CH;
    var g = c.getContext('2d'); (back ? d.back : d.front)(g, d);
    var t = document.createElement('canvas'); t.width = TW; t.height = TH;
    t.getContext('2d').drawImage(c, 0, 0, TW, TH);
    return t;
  }

  /* ---------- GL ---------- */
  var VS = 'attribute vec3 aP;attribute vec3 aN;attribute vec2 aU;attribute float aF;uniform mat4 uM,uV,uP;varying vec3 vN,vW;varying vec2 vU;varying float vF;' +
    'void main(){vec4 w=uM*vec4(aP,1.);vW=w.xyz;vN=mat3(uM)*aN;vU=aU;vF=aF;gl_Position=uP*uV*w;}';
  var FS = 'precision highp float;uniform sampler2D uA,uB;uniform vec3 uE,uC;uniform float uS;varying vec3 vN,vW;varying vec2 vU;varying float vF;' +
    'vec3 lin(vec3 c){return c*c;}' +
    'vec3 env(vec3 r){float band=exp(-pow((r.x+.2)/.1,2.))*smoothstep(-.45,.35,r.y);float top=smoothstep(.25,.95,r.y)*.32;float rim=exp(-pow((r.x-.6)/.08,2.))*smoothstep(-.5,.3,r.y)*.55;' +
    'return vec3(.02)+vec3(1.)*(1.4*band+top)+vec3(.9,.94,1.)*rim;}' +
    'void main(){vec3 n=normalize(vN);if(!gl_FrontFacing)n=-n;vec3 v=normalize(uC-vW);' +
    'vec3 b=vF<.5?texture2D(uA,vU).rgb:(vF<1.5?texture2D(uB,vU).rgb:uE);b=lin(b);' +
    'vec3 L1=normalize(vec3(-.45,.8,.6)),L2=normalize(vec3(.85,.15,.55));' +
    'float d1=max(dot(n,L1),0.),d2=max(dot(n,L2),0.);' +
    'vec3 col=b*(.34+.78*d1+.22*d2);' +
    'float sp=pow(max(dot(n,normalize(L1+v)),0.),36.);' +
    'float fr=.035+.965*pow(1.-max(dot(n,v),0.),5.);' +
    'col+=uS*(.12*sp+env(reflect(-v,n))*(.025+.55*fr)*.5);' +
    'col*=1.3;col=(col*(2.51*col+.03))/(col*(2.43*col+.59)+.14);' +
    'gl_FragColor=vec4(sqrt(clamp(col,0.,1.)),1.);}';
  var VSS = 'attribute vec2 aQ;uniform mat4 uM,uV,uP;varying vec2 vQ;void main(){vQ=aQ;gl_Position=uP*uV*uM*vec4(aQ.x,0.,aQ.y,1.);}';
  var FSS = 'precision mediump float;uniform float uO;varying vec2 vQ;void main(){float d=length(vQ);float a=pow(clamp(1.-d,0.,1.),1.8)*uO;gl_FragColor=vec4(0.,0.,0.,a);}';

  function prog(gl, vs, fs) {
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(o)); return o; }
    var p = gl.createProgram(); gl.attachShader(p, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(p, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
    return p;
  }
  function tex(gl, img, aniso) {
    var t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    if (aniso) gl.texParameterf(gl.TEXTURE_2D, aniso.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(8, gl.getParameter(aniso.MAX_TEXTURE_MAX_ANISOTROPY_EXT)));
    return t;
  }

  /* ---------- poses ---------- */
  // single: front for the first half of the pass, turns over as it crosses the middle
  function poseSingle(p, t, px, py) {
    var bob = reduce ? 0 : Math.sin(t * 1.1) * .05;
    return { m: ss(.46, .74, p), x: 0, y: bob, z: 0, rx: (8 + py * 7 + (reduce ? 0 : Math.sin(t * .8) * 1.5)) * D, yaw: (lerp(-24, 18, p) + px * 9) * D, rz: (-4 + (reduce ? 0 : Math.sin(t * .6) * 1.2)) * D };
  }
  // turn: one card that turns over every few seconds; each half-turn brings the next design round.
  // Scroll adds whole half-turns (eased in steps, so it never rests edge-on) and a little yaw.
  function stairs(v) { var f = Math.floor(v); return f + ss(.25, .75, v - f); }
  function poseTurn(p, t, px, py) {
    var P = 3.6, turn = 1.15, n = Math.floor(t / P), m = reduce ? 0 : n + ss(0, 1, (t - n * P - (P - turn)) / turn);
    m += reduce ? 0 : stairs(p * 3);
    var bob = reduce ? 0 : Math.sin(t * 1.05) * .06;
    return { m: m, x: 0, y: bob, z: 0, rx: (9 + py * 7 + (reduce ? 0 : Math.sin(t * .7) * 1.6)) * D, yaw: (-16 + p * 22 + px * 10) * D, rz: (-5 + (reduce ? 0 : Math.sin(t * .55) * 1.4)) * D };
  }

  function Card3D(el) {
    var cv = el.querySelector('canvas'); if (!cv) return;
    var gl = cv.getContext('webgl', { antialias: true, alpha: true, premultipliedAlpha: true }) || cv.getContext('experimental-webgl');
    if (!gl) return;
    var designs = (el.getAttribute('data-designs') || 'tap-black').split(',').map(function (s) { return s.trim(); });
    var mode = el.getAttribute('data-card3d') === 'turn' ? 'turn' : 'single';
    var P, S, buf, qbuf, texs = [], aniso = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
    try { P = prog(gl, VS, FS); S = prog(gl, VSS, FSS); } catch (e) { return; }
    var data = slab(), count = data.length / 9;
    buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    qbuf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, qbuf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
    designs.forEach(function (d) { texs.push({ a: tex(gl, face(d, false), aniso), b: tex(gl, face(d, true), aniso), d: DESIGNS[d] || DESIGNS['tap-black'] }); });
    el.classList.add('is-gl');

    var L = {
      p: { aP: gl.getAttribLocation(P, 'aP'), aN: gl.getAttribLocation(P, 'aN'), aU: gl.getAttribLocation(P, 'aU'), aF: gl.getAttribLocation(P, 'aF'),
           uM: gl.getUniformLocation(P, 'uM'), uV: gl.getUniformLocation(P, 'uV'), uP: gl.getUniformLocation(P, 'uP'), uA: gl.getUniformLocation(P, 'uA'), uB: gl.getUniformLocation(P, 'uB'),
           uE: gl.getUniformLocation(P, 'uE'), uC: gl.getUniformLocation(P, 'uC'), uS: gl.getUniformLocation(P, 'uS') },
      s: { aQ: gl.getAttribLocation(S, 'aQ'), uM: gl.getUniformLocation(S, 'uM'), uV: gl.getUniformLocation(S, 'uV'), uP: gl.getUniformLocation(S, 'uP'), uO: gl.getUniformLocation(S, 'uO') }
    };
    var w = 0, h = 0, proj, view, camZ = 10, visible = false, raf = 0, t0 = performance.now(), px = 0, py = 0, tpx = 0, tpy = 0;

    function size() {
      var r = el.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = Math.max(1, Math.round(r.width * dpr)); h = Math.max(1, Math.round(r.height * dpr));
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      var a = w / h, fov = 26 * D, needW = W * (mode === 'turn' ? 1.75 : 1.5), needH = H * (mode === 'turn' ? 1.7 : 2.05);
      var dH = needH / 2 / Math.tan(fov / 2), dW = needW / a / 2 / Math.tan(fov / 2);
      camZ = Math.max(dH, dW); proj = persp(fov, a, .1, 100); view = trans(0, 0, -camZ);
    }
    function progress() {
      var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (mode === 'turn') { var top = el.closest('.trd-sec') || el; var rr = top.getBoundingClientRect(); return clamp(-rr.top / Math.max(1, rr.height * .85), 0, 1); }
      return clamp((vh - r.top) / (vh + r.height), 0, 1);
    }
    function draw() {
      raf = 0; if (!visible) return;
      var t = (performance.now() - t0) / 1000, p = reduce ? .25 : progress();
      px += (tpx - px) * .08; py += (tpy - py) * .08;
      var q = mode === 'turn' ? poseTurn(p, t, px, py) : poseSingle(p, t, px, py);
      gl.viewport(0, 0, w, h); gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      // soft floor shadow under the cards
      gl.disable(gl.DEPTH_TEST); gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      gl.useProgram(S); gl.bindBuffer(gl.ARRAY_BUFFER, qbuf); gl.enableVertexAttribArray(L.s.aQ); gl.vertexAttribPointer(L.s.aQ, 2, gl.FLOAT, false, 0, 0);
      gl.uniformMatrix4fv(L.s.uV, false, view); gl.uniformMatrix4fv(L.s.uP, false, proj);
      var spread = mode === 'turn' ? 2.1 : 1.9;
      gl.uniformMatrix4fv(L.s.uM, false, mul(trans(0, -H * .98, -.4), scal(spread, 1, .55)));
      gl.uniform1f(L.s.uO, mode === 'turn' ? .3 : .34); gl.drawArrays(gl.TRIANGLES, 0, 6);
      gl.disableVertexAttribArray(L.s.aQ);
      // cards
      gl.disable(gl.BLEND); gl.enable(gl.DEPTH_TEST); gl.useProgram(P); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      var st = 36;
      [['aP', 3, 0], ['aN', 3, 12], ['aU', 2, 24], ['aF', 1, 32]].forEach(function (a) { gl.enableVertexAttribArray(L.p[a[0]]); gl.vertexAttribPointer(L.p[a[0]], a[1], gl.FLOAT, false, st, a[2]); });
      gl.uniformMatrix4fv(L.p.uV, false, view); gl.uniformMatrix4fv(L.p.uP, false, proj); gl.uniform3f(L.p.uC, 0, 0, camZ);
      gl.uniform1i(L.p.uA, 0); gl.uniform1i(L.p.uB, 1);
      // the front shows design ⌊(m+1)/2⌋ and the back ⌊m/2⌋: each swap happens while that face is turned away
      var nT = texs.length, fa = texs[Math.floor((q.m + 1) / 2) % nT], fb = texs[Math.floor(q.m / 2) % nT], facing = Math.cos(q.m * Math.PI) >= 0 ? fa : fb;
      var mm = mul(trans(q.x, q.y, q.z), mul(ry(q.m * Math.PI + q.yaw), mul(rx(q.rx), rz(q.rz))));
      gl.uniformMatrix4fv(L.p.uM, false, mm); gl.uniform3fv(L.p.uE, facing.d.edge); gl.uniform1f(L.p.uS, facing.d.sheen);
      gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, fa.a); gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, fb.b);
      gl.drawArrays(gl.TRIANGLES, 0, count);
      if (!reduce || mode === 'turn') loop();
    }
    function loop() { if (!raf && visible) raf = requestAnimationFrame(draw); }

    size();
    if ('ResizeObserver' in window) new ResizeObserver(function () { size(); loop(); }).observe(el); else window.addEventListener('resize', function () { size(); loop(); });
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) loop(); }, { rootMargin: '120px' }).observe(el);
    window.addEventListener('scroll', loop, { passive: true });
    if (!reduce && window.matchMedia('(hover:hover)').matches) {
      window.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
        tpx = clamp((e.clientX - (r.left + r.width / 2)) / (r.width / 2 + 200), -1, 1);
        tpy = clamp((e.clientY - (r.top + r.height / 2)) / (r.height / 2 + 200), -1, 1);
      }, { passive: true });
    }
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); el.classList.remove('is-gl'); visible = false; });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) loop(); });
  }

  function boot() {
    var els = document.querySelectorAll('[data-card3d]'); if (!els.length) return;
    var lp = document.querySelector('.trd-c3d .trd-logo path, svg.trd-logo path'), qp = document.querySelector('.trd-c3d .trd-nfcc__code svg path');
    ART.logo = lp ? lp.getAttribute('d') : ''; ART.qr = qp ? qp.getAttribute('d') : '';
    var ic = document.querySelector('.trd-c3d .trd-nfcc__code img');
    function one(el) { try { Card3D(el); } catch (e) { /* the HTML card stays */ } }
    /* Each card builds its WebGL scene only when it comes near the screen; the HTML card shows until then. */
    function go() {
      if (!('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) one(els[i]); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); one(e.target); } });
      }, { rootMargin: '600px 0px' });
      for (var i = 0; i < els.length; i++) io.observe(els[i]);
    }
    var waits = [];
    if (document.fonts && document.fonts.load) waits.push(Promise.all([document.fonts.load("600 40px Inter"), document.fonts.load("700 40px Inter")]).catch(function () {}));
    if (ic) waits.push(new Promise(function (res) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { ART.icon = im; res(); }; im.onerror = res; im.src = ic.currentSrc || ic.src; }));
    Promise.all(waits).then(go, go);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
